import React from "react";
import { Col, Checkbox, Row } from "antd";
import "../styles.css";

const spanstyles = {
  marginRight: 8,
};

export const getRecycleBinDefaultSettings = {
  recycle_bin_view: false,
  recycle_bin_restore: false,
  recycle_bin_empty: false,
};

function RecycleBinSettings(props) {
  return (
    <div className="app_config_checkbox_class2">
      <Row>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "recycle_bin_view"
                )
              }
              checked={props.config.recycle_bin_view}
            />
          </span>
          <span style={spanstyles}>View</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "recycle_bin_restore"
                )
              }
              checked={props.config.recycle_bin_restore}
            />
          </span>
          <span style={spanstyles}>Restore</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "recycle_bin_empty"
                )
              }
              checked={props.config.recycle_bin_empty}
            />
          </span>
          <span style={spanstyles}>Empty</span>
        </Col>
      </Row>
    </div>
  );
}

export default React.memo(RecycleBinSettings);
